export const FormatDate = (date) => {
    return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear().toString().substring(2);
};

export const UrlQueryParam = (param) => {
    return (new URL(window.location.href)).searchParams.get(param);
};